import { HttpBackend, HttpClient } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';
import { AuthEndpoints } from '@core/constants/endpoints.const';
import { IAppConfig } from '@models/app-config/app.config.model';
import {
  IChangePasswordModel,
  ICurrentUserModel,
  ILoginResponseModel,
  IResetPasswordModel,
  IUserOTPVerificationModel,
} from '@models/auth/auth.model';
import { ApiResponse } from '@models/response.model';
import { APP_CONFIG_SERIVCE } from '@services/common/appconfig.service';
import { CurrentUserService } from '@services/common/currentuser.service';
import { map } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class AuthService {
  private httpClient: HttpClient;

  constructor(
    handler: HttpBackend,
    // private httpClient: HttpClient,
    public currentUserService: CurrentUserService,
    @Inject(APP_CONFIG_SERIVCE) public appConfig: IAppConfig
  ) {
    this.httpClient = new HttpClient(handler);
  }

  login = (data: any) => {
    return this.httpClient.post<ApiResponse<ILoginResponseModel>>(
      `${this.appConfig?.apiEndpoint}${AuthEndpoints.Login}`,
      data,
      {
        observe: 'response',
      }
    );
  };

  logout() {
    // Logout user as well as remove current user from storage
    const currentUser: ICurrentUserModel = this.currentUserService.get();
    return this.httpClient
      .post<ApiResponse<any>>(
        `${this.appConfig?.apiEndpoint}${AuthEndpoints.Logout}?id=${currentUser?.refId}&userTypeId=${currentUser?.userTypeId}`,
        null
      )
      .pipe(
        map(() => {
          this.currentUserService.logout();
        })
      );
  }

  verifyOtp(responseBody: IUserOTPVerificationModel) {
    return this.httpClient.post<ApiResponse<ILoginResponseModel>>(
      `${this.appConfig?.apiEndpoint}${AuthEndpoints.VerifyOtp}`,
      responseBody
    );
  }

  forgotPassword = (emailId: string) => {
    return this.httpClient.post<ApiResponse<any>>(
      `${this.appConfig?.apiEndpoint}${AuthEndpoints.ForgotPassword}?emailId=${emailId}`,
      null
    );
  };

  isAuthenticated() {
    const currentUser: ICurrentUserModel = this.currentUserService.get();

    const expiresIn = new Date(currentUser?.expiration);
    const currentDate = new Date();
    return (
      !!(currentUser && currentUser?.jwtToken) &&
      currentDate &&
      expiresIn &&
      currentDate <= expiresIn
    );
  }

  isUnAuthenticated() {
    const currentUser: ICurrentUserModel = this.currentUserService.get();
    const expiration = new Date(currentUser?.expiration);
    const currentDate = new Date();
    return (
      !currentUser ||
      (!!currentUser && !currentUser?.jwtToken) ||
      (!!currentUser && currentDate > expiration)
    );
  }

  resetPassword(resetPassword: IResetPasswordModel) {
    return this.httpClient.post<ApiResponse<any>>(
      `${this.appConfig?.apiEndpoint}${AuthEndpoints.ResetPassword}`,
      resetPassword,
      {
        observe: 'response',
      }
    );
  }

  resendOtp(email: string) {
    return this.httpClient.post<ApiResponse<any>>(
      `${this.appConfig?.apiEndpoint}${AuthEndpoints.ResendOTP}?email=${email}`,
      null
    );
  }

  changePassword(changePasswordModel: IChangePasswordModel) {
    return this.httpClient.post<ApiResponse<any>>(
      `${this.appConfig?.apiEndpoint}${AuthEndpoints.ChangePassword}`,
      changePasswordModel
    );
  }
}
